module.exports = __webpack_public_path__ + "img/horizontal-banner.3b513558.png";